import React, { useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
} from "reactstrap";
import BasicModal from '../../../../components/Modals/BasicModal'
import {periodLabels} from '../../../../utils/views/pages/StaticPatterns'

const SubscriptionInformation = (props) => {
    const subscription = props.subscription
    const formDisabled = props.formDisabled
    const [showModal, setShowModal] = useState(false)
    const [warning, setWarning] = useState("")    

    return (
        <>
            <h6 className="heading-small text-muted mb-4">
                Subscription information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-app"
                            >
                                App
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={subscription?.plan?.app?.name}
                                id="input-app"
                                name="app"
                                placeholder="Subscription App"
                                type="text"
                                disabled={formDisabled}
                                required={true}
                            />
                        </FormGroup>
                    </Col> 
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-plan"
                            >
                                Plan
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={subscription?.plan?.name}
                                id="input-plan"
                                name="plan"
                                placeholder="Subscription Plan Name"
                                type="text"
                                disabled={formDisabled}
                                required={true}
                            />
                        </FormGroup>
                    </Col> 
                                                                                     
                </Row>
                <Row>                    
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-periodicity"
                            >
                                Periodicity
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={periodLabels[subscription?.plan?.periodicity]}
                                id="input-periodicity"
                                name="periodicity"
                                placeholder="Subscription Plan Periodicity"
                                type="text"
                                disabled={formDisabled}
                                required={true}
                            />
                        </FormGroup>
                    </Col>  
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-licensesLimit"
                            >
                                Licenses
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={subscription?.licensesLimit}
                                id="input-licensesLimit"
                                name="licensesLimit"
                                placeholder="Subscription Licenses"
                                type="text"
                                disabled={formDisabled}
                                required={true}
                            />
                        </FormGroup>
                    </Col>      
                    
                    
                </Row>

            </div>

            <BasicModal
                title="Warning"
                message={warning}
                showModal={showModal}
                setShowModal={setShowModal} />
        </>
    )
}

export default SubscriptionInformation;